import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Forces scroll-to-top on every route change.
 *
 * Why this is multi-step:
 *   1. We disable browser scroll-restoration once on mount so it doesn't fight us.
 *   2. We use a microtask + rAF + a 0/100/300ms cascade to win the race against
 *      lazy-loaded images, CSS layout shifts and any browser-internal restoration
 *      that may run after the SPA route swap.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    if (hash) return;
    const top = () => window.scrollTo(0, 0);
    top();
    const r1 = requestAnimationFrame(top);
    const t1 = setTimeout(top, 0);
    const t2 = setTimeout(top, 100);
    const t3 = setTimeout(top, 300);
    return () => {
      cancelAnimationFrame(r1);
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
